<template>
  <div id="onebyone-gateway">
    <div id="top-campaign-carousel" v-if="topCampaigns">
      <div
        class="top-campaign-carousel-controller icon-sprite carousel-left-controller"
        @click="carouselModel--"
      ></div>
      <div
        class="top-campaign-carousel-controller icon-sprite carousel-right-controller"
        @click="carouselModel++"
      ></div>
      <v-carousel height="250px" hide-delimiters :show-arrows="false" cycle v-model="carouselModel">
        <v-carousel-item
          v-for="(campaign, index) in topCampaigns"
          style="height:auto;"
          :key="index"
          :to="campaign.url"
          eager
          :ripple="false"
          :src="getImage(campaign.image)"
        ></v-carousel-item>
      </v-carousel>
    </div>
    <div id="new-release-campaign-wrapper" class="mt-2" v-if="newReleasesCampaignProducts">
      <div
        id="new-release-campaign-content"
        class="campaign-content-section"
        v-for="(newReleaseProduct, index) in newReleasesCampaignProducts"
        :key="index"
      >
        <v-img :src="getImage(newReleaseProduct.image)"></v-img>
        <div
          id="new-release-campaign-description-wrapper"
          class="text-center noto-sans-sc-font-family d-flex flex-column justify-space-around"
        >
          <div id="new-release-campaign-title">{{ parseMetadata(newReleaseProduct.metadata).title }}</div>
          <div
            id="new-release-product-full-title"
          >{{ parseMetadata(newReleaseProduct.metadata).subtitle }}</div>
          <div class="mobile-gateway-more-button mx-auto">VIEW DETAILS</div>
        </div>
      </div>
    </div>
    <div id="best-seller-campaign-wrapper" v-if="bestSellerCampaignProducts">
      <div id="best-seller-campaign-content" class="campaign-content-section text-center">
        <div id="best-seller-title" class="verdana-font-family my-4">Bestsellers</div>
      </div>
      <div id="best-seller-products-section-wrapper">
        <div
          class="best-seller-single-product-wrapper text-center noto-sans-sc-font-family py-6 mt-5"
          v-for="(product, index) in bestSellerCampaignProducts"
          :key="index"
        >
          <div class="best-seller-product-title mt-1">{{ parseMetadata(product.metadata).title }}</div>
          <div
            class="best-seller-product-description"
          >{{ parseMetadata(product.metadata).description }}</div>
          <div class="best-seller-product-image py-6">
            <v-img :src="getImage(product.image)" max-width="140px" contain class="mx-auto"></v-img>
          </div>
          <router-link :to="product.url">
            <div class="mobile-gateway-more-button mx-auto">SHOP NOW</div>
          </router-link>
        </div>
      </div>
    </div>
    <div id="mobile-gateway-shop-now-section" class="my-7">
      <router-link to="/product/browse">
        <div
          id="shop-now-button"
          class="text-uppercase verdana-font-family text-center mx-auto py-2"
        >shop all ></div>
      </router-link>
    </div>
    <v-divider></v-divider>
    <div
      id="mobile-gateway-subscribe-section-container"
      class="noto-sans-sc-font-family text-center my-6 d-flex flex-column align-center"
    >
      <div id="subscribe-title">Subscribe To Our Newsletter</div>
      <div
        id="subscribe-description"
        class="mt-2"
      >Receive news, special promotions, new product information and exclusive content</div>
      <div id="subscribe-form-container" class="d-flex mt-5">
        <input
          id="subscribe-form-email-field"
          type="text"
          placeholder="Enter Your Email"
          v-model="subscribeEmail"
        />
        <v-btn tile depressed height="40px" color="#e2211c" class="white--text">subscribe</v-btn>
      </div>
      <div
        id="subscribe-term-condition"
        class="font-italic my-5"
      >By clicking 'Subscribe', you agree to Term of Use and Privacy Policy. We take your privacy seriously and never share your information</div>
    </div>
  </div>
</template>
<script>
import homepageMixins from "../../mixins/homepageMixins";
import { defaultAxiosConfig } from "../../api/apiConfig";
export default {

   created:function(){
    
     this.mobileHomeRecord();
    },


     methods: {
     mobileHomeRecord(){
        this.$axios({
              url: defaultAxiosConfig.baseURL+"/website/totalData",
              //  url: "http://localhost:5000/website/totalData",
              method: "post",
              params: {"location": "home","type": "mobile"}
            }).then(res => {
              console.log(res);
            });
     }

   },

  mixins: [homepageMixins("mobile")],
  metaInfo: {
    title:
      "1byone health |  body fat scale, blood pressure monitor, oximeter, tens and etc",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "1byone health features houshold health products including bluetooth body fat scale,  blood pressure monitor, oximeter, tens and more, providing professional service, technology and best products."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone, 1byone.com, 1byonehealth.com, 1byonehealth, health, zoetouch, beautural, bluetooth, body fat scale, bathroom scale, smart scale, body scale, scale, oximeter, blood pressure monitor, tens"
      }
    ]
  },

  data: () => ({
    carouselModel: 0,
    subscribeEmail: ""
  })
};
</script>

<style scoped>
#onebyone-gateway {
  max-width: 2000px;
  margin: auto;
}

.product-campaign-card {
  border-radius: 5px;
}

#top-campaign-carousel {
  position: relative;
  z-index: 0;
}

.top-campaign-carousel-controller {
  position: absolute;
  z-index: 1;
  height: 40px;
  width: 40px;
  background-size: 250px;
}

.carousel-left-controller {
  background-position: 10px -165px;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
}

.carousel-right-controller {
  background-position: -35px -165px;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
}

#new-release-campaign-description-wrapper {
  height: 125px;
}

#new-release-campaign-title {
  color: #e2211c;
  font-size: 19px;
}

#new-release-product-full-title {
  color: #666666;
  font-size: 14px;
}

.mobile-gateway-more-button {
  background-color: #e2211c;
  text-transform: uppercase;
  color: white;
  padding-top: 9px;
  padding-bottom: 9px;
  width: 120px;
  font-family: "Verdana", sans-serif !important;
  font-size: 13px;
}

.best-seller-single-product-wrapper {
  background-color: #f5f5f5;
}

#best-seller-title {
  font-size: 35px;
  color: #333333;
}

.best-seller-product-title {
  font-size: 17px;
  font-weight: 500;
  color: #333335;
}

.best-seller-product-description {
  color: #999999;
  font-size: 14px;
}

#shop-now-button {
  border: 1px solid #e2211c;
  width: 130px;
  color: #e2211c;
}

#subscribe-title {
  color: #333333;
  font-size: 17px;
}

#subscribe-description {
  color: #666666;
  font-size: 13px;
  width: 80%;
}

#subscribe-form-email-field {
  max-width: 180px;
  padding: 10px;
  height: 40px;
  border: 1px solid #e6e6e6;
}

#subscribe-term-condition {
  color: #999999;
  font-size: 12px;
  width: 80%;
}
</style>


